import {
  NUMBER_SHARE_ELIGIBILITY_ERROR,
  NUMBER_SHARE_ELIGIBILITY_REQUEST,
  NUMBER_SHARE_ELIGIBILITY_SUCCESS,
  NUMBER_SHARE_ERROR,
  NUMBER_SHARE_REQUEST,
  NUMBER_SHARE_SUCCESS,
  SERVICE_NUMBER_SHARE_ERROR,
  SERVICE_NUMBER_SHARE_REQUEST,
  SERVICE_NUMBER_SHARE_SUCCESS
} from '@/actions/numberShare/actionTypes';

export const initialState = {
  numberShareDetails: {},
  numberShareLoading: false,
  serviceNumbersList: [],
  serviceNumberLoading: false,
  numberShareEligibility: false,
  isLoading: false,
  numberShareError: ''
};

const numberShareReducers = (state = initialState, action) => {
  switch (action.type) {
    case NUMBER_SHARE_REQUEST:
      return {
        ...state,
        numberShareLoading: true,
        numberShareError: ''
      };
    case NUMBER_SHARE_SUCCESS:
      return {
        ...state,
        numberShareDetails: action.data,
        numberShareLoading: false
      };
    case NUMBER_SHARE_ERROR:
      return {
        ...state,
        numberShareDetails: {},
        numberShareLoading: false,
        numberShareError: action.error.response?.data?.message
      };

    case SERVICE_NUMBER_SHARE_REQUEST:
      return {
        ...state,
        serviceNumberLoading: true,
        numberShareError: ''
      };
    case SERVICE_NUMBER_SHARE_SUCCESS:
      return {
        ...state,
        serviceNumbersList: action.data,
        serviceNumberLoading: false
      };
    case SERVICE_NUMBER_SHARE_ERROR:
      return {
        ...state,
        serviceNumbersList: [],
        serviceNumberLoading: false,
        numberShareError: action.error.response?.data?.message
      };

    case NUMBER_SHARE_ELIGIBILITY_REQUEST:
      return {
        ...state,
        isLoading: true,
        numberShareError: ''
      };
    case NUMBER_SHARE_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        numberShareEligibility: action.data,
        isLoading: false
      };
    case NUMBER_SHARE_ELIGIBILITY_ERROR:
      return {
        ...state,
        numberShareEligibility: false,
        isLoading: false,
        numberShareError: action.error.response?.data?.message
      };

    default:
      return state;
  }
};

export default numberShareReducers;
